import { render, staticRenderFns } from "./PlanControlItem.vue?vue&type=template&id=20299e94&scoped=true&"
import script from "./PlanControlItem.vue?vue&type=script&lang=js&"
export * from "./PlanControlItem.vue?vue&type=script&lang=js&"
import style0 from "./PlanControlItem.vue?vue&type=style&index=0&id=20299e94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20299e94",
  null
  
)

export default component.exports